import React from 'react'
import { Field, reduxForm } from 'redux-form'

import Captcha from '../../Captcha/Captcha'
import PlaceField from '../../PlaceField/PlaceField'

import addressLeadFormContainer from './addressLeadFormContainer'
import './AddressLeadForm.css'

import LeadFormSubmitButton from './LeadFormSubmitButton'

const hideEmailField = process.env.REACT_APP_SKIP_HOME_LEAD_CREATE === '1'

export const AddressLeadForm = ({
  busy,
  handleSubmit,
  onAddressSelect,
  ready,
  submitting,
  years,
  appConfig: {
    phoneInput,
    birthdayInput,
    firstNameInput,
    lastNameInput,
    optInInput,
    whenRunningInput,
    whenRunningOptions,
  },
  errorMessage,
}) => {
  const months = process.env.REACT_APP_MONTHS.split(',')
  const showSubmitButtonBeforeEnd = !optInInput.enabled

  return (
    <form onSubmit={handleSubmit}>
      {errorMessage && (
        <div className="alert AddressLeadForm__leadError">{errorMessage}</div>
      )}
      <Field name="g-recaptcha-response" component={Captcha} />

      {(firstNameInput.enabled || lastNameInput.enabled) && (
        <React.Fragment>
          <div className="form-row align-items-end">
            {firstNameInput.enabled && (
              <div className="form-group col-md">
                <label htmlFor="first_name" className="AddressLeadForm__label">
                  First Name
                </label>
                <Field
                  className="form-control AddressLeadForm__input"
                  component="input"
                  id="first_name"
                  name="first_name"
                  placeholder="Jane"
                  required={firstNameInput.required}
                  type="text"
                />
              </div>
            )}
            {lastNameInput.enabled && (
              <div className="form-group col-md">
                <label htmlFor="last_name" className="AddressLeadForm__label">
                  Last Name
                </label>
                <Field
                  className="form-control AddressLeadForm__input"
                  component="input"
                  id="last_name"
                  name="last_name"
                  placeholder="Smith"
                  required={lastNameInput.required}
                  type="text"
                />
              </div>
            )}
          </div>
        </React.Fragment>
      )}

      <div className="form-row align-items-end">
        {!hideEmailField && (
          <div className="form-group col-md">
            <label htmlFor="email" className="AddressLeadForm__label">
              Email Address
            </label>
            <Field
              className="form-control AddressLeadForm__input"
              component="input"
              id="email"
              name="email"
              placeholder="user@example.com"
              required
              type="email"
            />
          </div>
        )}

        <div className="form-group col-md AddressLeadForm__address-form-group">
          <label htmlFor="address" className="AddressLeadForm__label">
            Your Address
          </label>
          <Field
            className="form-control AddressLeadForm__input"
            component={PlaceField}
            id="address"
            name="address"
            onSelect={onAddressSelect}
            placeholder={`e.g., ${process.env.REACT_APP_PLACEHOLDER_ADDRESS}`}
            required
            type="text"
          />
        </div>

        {years.length > 1 && (
          <div className="form-group col-md">
            <label className="AddressLeadForm__label" htmlFor="year">
              When are you interested in running?
            </label>
            <Field
              className="form-control AddressLeadForm__select"
              component="select"
              id="year"
              name="year"
              required
            >
              {years.map((year, key) => (
                <option key={key} value={year}>
                  {year}
                </option>
              ))}
            </Field>
          </div>
        )}

        {phoneInput.enabled && (
          <div className="form-group col-md">
            <label htmlFor="phone" className="AddressLeadForm__label">
              Phone Number
            </label>

            <Field
              className="form-control AddressLeadForm__input"
              component="input"
              id="phone"
              name="phone"
              placeholder="000-000-0000"
              required={phoneInput.required}
              type="phone"
            />
          </div>
        )}
        {birthdayInput.enabled
          ? null
          : showSubmitButtonBeforeEnd && (
              <LeadFormSubmitButton busy={busy} submitting={submitting} />
            )}
      </div>

      {birthdayInput.enabled && (
        <React.Fragment>
          <div className="form-row">
            <div className="col AddressLeadForm__label__title">Birthday</div>
          </div>
          <div className="form-row align-items-end">
            <div className="form-group col-md">
              <label
                htmlFor="birthday_month"
                className="AddressLeadForm__label"
              >
                Month
              </label>
              <Field
                className="custom-select AddressLeadForm__input"
                component="select"
                id="birthday_month"
                name="birthday_month"
                required={birthdayInput.required}
                type="text"
              >
                <option></option>
                {months.map((month, key) => (
                  <option key={key} value={key + 1}>
                    {month}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group col-md">
              <label htmlFor="birthday_day" className="AddressLeadForm__label">
                Day
              </label>
              <Field
                className="form-control AddressLeadForm__input"
                component="input"
                id="birthday_day"
                name="birthday_day"
                required={birthdayInput.required}
                type="number"
                min="1"
                max="31"
              />
            </div>
            <div className="form-group col-md">
              <label htmlFor="birthday_year" className="AddressLeadForm__label">
                Year
              </label>
              <Field
                className="form-control AddressLeadForm__input"
                component="input"
                id="birthday_year"
                name="birthday_year"
                required={birthdayInput.required}
                type="number"
                min="1900"
              />
            </div>
            {showSubmitButtonBeforeEnd && (
              <LeadFormSubmitButton busy={busy} submitting={submitting} />
            )}
          </div>
        </React.Fragment>
      )}

      {whenRunningInput.enabled && (
        <React.Fragment>
          <div className="form-row">
            <div className="col AddressLeadForm__label__title">
              Are you currently running for office?
            </div>
          </div>
          <div className="form-row align-items-end">
            <div className="form-group col-md">
              <Field
                className="custom-select AddressLeadForm__input"
                component="select"
                id="wants_to_run_when"
                name="wants_to_run_when"
                required={whenRunningInput.required}
                type="text"
              >
                <option></option>
                {whenRunningOptions.map((option, key) => (
                  <option key={key} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
        </React.Fragment>
      )}

      {optInInput.enabled && (
        <React.Fragment>
          <div className="form-row align-items-end AddressLeadForm__row__optin">
            <div className="form-check col-md AddressLeadForm__col__optin">
              <Field
                className="form-check-input AddressLeadForm__input"
                component="input"
                id="opt_in"
                name="opt_in"
                type="checkbox"
              />
              <label
                htmlFor="opt_in"
                className="AddressLeadForm__label form-check-label"
              >
                {optInInput.text}
                {optInInput.urlLink && optInInput.urlText && (
                  <React.Fragment>
                    <br />
                    <a href={optInInput.urlLink} target="_blank">
                      {optInInput.urlText}
                    </a>
                  </React.Fragment>
                )}
              </label>
            </div>
          </div>
          <div className="form-row align-items-end AddressLeadForm__row__optin">
            <LeadFormSubmitButton busy={busy} submittin={submitting} />
          </div>
        </React.Fragment>
      )}
    </form>
  )
}

export default addressLeadFormContainer(
  reduxForm({ form: 'addressLeadForm' })(AddressLeadForm),
)



// WEBPACK FOOTER //
// ./src/components/HomeScene/AddressLeadForm/AddressLeadForm.js